import { Hidden } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { scheduleHoursTableStyles } from '../../../../../global/constants/theme/styles/tables/scheduled-hours-table';
import { getFormattedDate } from '../../../../../global/helpers/date-helpers';
import { useBasePath } from '../../../../../global/hooks/useBasePath';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { ArcRoutes } from '../../../constants/routes';
import { CompensationProps } from '../../../models/arc-epi-props';
import { ScheduledHours } from '../../employment/employment-model';

interface ItemProps {
	row: ScheduledHours;
	dateLabel: string;
	scheduledHoursLabel: string;
	editLabel: string;
	editRoute: string;
	presentDateLabel: string;
	editDisabled: boolean;
}

const ScheduledHoursRow = (props: ItemProps) => {
	const { row, dateLabel, scheduledHoursLabel, editRoute, editLabel, presentDateLabel, editDisabled } = props;

	const endDate = row.end_date ? getFormattedDate(row.end_date) : (presentDateLabel || 'Present');

	return (
		<div className='scheduled-hours-table-row'>
			<div className='scheduled-hours-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{dateLabel}</p>
				</Hidden>
				<div>{`${getFormattedDate(row.start_date)} - ${endDate}`}</div>
			</div>
			<div className='scheduled-hours-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{scheduledHoursLabel}</p>
				</Hidden>
				<div>{row.hours}</div>

				{!editDisabled && <Link className='edit-link' to={editRoute}>{editLabel}</Link>}
			</div>
		</div>
	);
};


interface Props {
	scheduledHours: ScheduledHours[];
	labelSettings: LabelSettingProps;
	compensationProps: CompensationProps;
	editDisabled: boolean;
}
export function ScheduledHoursHistoryView(props: Props) {
	const { scheduledHours, compensationProps, labelSettings, editDisabled } = props;

	const basePath = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.PeopleRoot}${ArcRoutes.Compensation}`);
	const tableClasses = scheduleHoursTableStyles();

	if (!scheduledHours || scheduledHours.length < 1) {
		return (<div dangerouslySetInnerHTML={{ __html: compensationProps?.noScheduledHoursHistory }} />);
	}

	return (
		<div className={tableClasses.scheduleHoursTable}>
			<Hidden xsDown>
				<div className='scheduled-hours-table-row'>
					<div className='scheduled-hours-table-row-cell'>
						<p className='input-label'>{compensationProps?.scheduledHoursDateLabel}</p>
					</div>
					<div className='scheduled-hours-table-row-cell'>
						<p className='input-label'>{compensationProps?.scheduledHoursLabel}</p>
					</div>
				</div>
			</Hidden>
			<div className='scheduled-hours-table-content'>
				{scheduledHours.map(row => {
					return (
						<ScheduledHoursRow
							key={row.id}
							row={row}
							dateLabel={compensationProps?.scheduledHoursDateLabel}
							scheduledHoursLabel={compensationProps?.scheduledHoursLabel}
							editLabel={labelSettings?.editLabel}
							editRoute={`${basePath}${ArcRoutes.ScheduledHours}/${row.id}`}
							presentDateLabel={labelSettings?.presentDateLabel}
							editDisabled={editDisabled}
						/>
					);
				})}
			</div>
		</div>
	);
}
